import React from 'react';
import { motion } from 'framer-motion';
import './EmptyState.css';

const EmptyState = ({ 
  icon, 
  title, 
  description, 
  action, 
  actionText 
}) => {
  return (
    <motion.div 
      className="empty-state"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {icon && (
        <div className="empty-state-icon">
          {icon}
        </div>
      )}
      <h3 className="empty-state-title">{title}</h3>
      {description && (
        <p className="empty-state-description">{description}</p>
      )}
      {action && actionText && (
        <button 
          className="empty-state-action"
          onClick={action}
        >
          {actionText}
        </button>
      )}
    </motion.div>
  );
};

export default EmptyState;